// extracted by mini-css-extract-plugin
export default {"preview-container":"code-drag-preview-item__preview-container--tkmRA","previewContainer":"code-drag-preview-item__preview-container--tkmRA"};